exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clinic-provider-product .modal-dialog{max-width:1440px}", ""]);

// exports
